module.exports = __webpack_public_path__ + "static/media/logo.e07df127.png";